import { render } from "./SideBarSubMenuItem.vue?vue&type=template&id=5eef0495"
import script from "./SideBarSubMenuItem.vue?vue&type=script&lang=js"
export * from "./SideBarSubMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__